interface MountainDividerProps {
  /** Clases extra para el contenedor (p. ej. color de fondo de la sección superior) */
  className?: string;
  /** Clases aplicadas al SVG (p. ej. `text-secondary`) */
  svgClassName?: string;
  /** Rota 180° para usar como cierre en vez de apertura */
  flip?: boolean;
  /** Altura del divisor en móvil / desktop */
  heightClass?: string;
}

/**
 * Divisor decorativo con picos andinos, inspirado en la base
 * montañosa del logo de Huaytanatura.
 */
export function MountainDivider({
  className = '',
  svgClassName = 'text-secondary',
  flip = false,
  heightClass = 'h-[50px] md:h-[70px]',
}: MountainDividerProps) {
  return (
    <div
      aria-hidden="true"
      className={`w-full overflow-hidden leading-none ${flip ? 'rotate-180' : ''} ${className}`}
    >
      <svg
        viewBox="0 0 1440 90"
        preserveAspectRatio="none"
        className={`block w-full ${heightClass} ${svgClassName}`}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0,90 L0,58 L90,34 L190,60 L290,18 L390,52 L470,38 L560,66 L660,22 L760,56 L850,40 L940,68 L1040,26 L1140,58 L1240,36 L1330,62 L1440,42 L1440,90 Z"
          fill="currentColor"
        />
      </svg>
    </div>
  );
}